<template>
  <div class="bg-white">
    <div class="mx-auto max-w-3xl px-4 py-10 lg:px-0 flex flex-col gap-1">
      <Headline title="Sie haben Fragen?"/>
      <p class="text-center font-normal leading-6 text-gray-700 text-md">
        Unser Kundenservice steht Ihnen per Telefon oder E-Mail jederzeit zur Verfügung.
      </p>
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div class="mx-auto grid sm:my-4">
          <img class="mx-auto h-20 w-20 rounded-full object-cover" src="/images/marcodenner.jpg" alt="">
          <div class="my-4 text-center text-sm leading-4 text-gray-700">
            <h3 class="text-green-400">Ansprechpartner: Marco Denner</h3>
            <p>Serviceteam von heysafe</p>
          </div>
        </div>
        <div class="mx-auto mt-2 flex flex-col gap-y-4 md:mt-10">
          <div v-for="contact in contactPossibilities" v-bind:key="contact.screenReaders">
            <dt class="sr-only text-gray-700"> {{ contact.screenReaders }}</dt>
            <dd class="flex">
              <i class="text-xl text-green-400"
                 :class="contact.icon"></i>
              <span class="ml-3 text-base text-gray-700">
                  <a :href="contact.link">{{ contact.linkText }}</a><br>
                  <p v-if="contact.info">{{ contact.info }}</p>
              </span>
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Headline from "../../common/components/Headline";

const contactPossibilities = [
  {
    screenReaders: 'Phone number',
    link: 'tel:+4921154268300',
    linkText: '0211 54 26 83 00',
    info: '(Mo-Fr 8–18 Uhr, zum Ortstarif)',
    icon: 'far fa-phone-alt'
  },
  {
    screenReaders: 'Email',
    link: 'mailto:info@heysafe.de',
    linkText: 'info@heysafe.de',
    info: '',
    icon: 'far fa-envelope'
  },
];
</script>
